import { ChangeEvent, useState } from "react";
import SubmitSkeleton from "../SubmitSkeleton";
import { capitalizeFirstLetters } from "../../../utils/stringUtils";
import { useCaseContext } from "../../../context/CaseContext";
import { allSubCases } from "../resources";

const WhatToReportStage = ({
  setStep,
}: {
  setStep: (step: number) => void;
}) => {
  const [errorMessage, setErrorMessage] = useState("");

  const { caseType, subCaseType, updateCaseData } = useCaseContext();

  const handlePrev = () => {
    setStep(0);
  };

  const canProceed =
    subCaseType &&
    ((typeof subCaseType === "string" && subCaseType?.length > 0) ||
      (typeof subCaseType === "object" &&
        subCaseType.custom &&
        subCaseType.customValue));

  const handleNext = () => {
    if (canProceed) {
      setErrorMessage("");
      setStep(2);
    } else {
      setErrorMessage("Please select an option before proceeding.");
    }
  };

  const handleChange = (choice: string) => {
    if (choice === "other") {
      updateCaseData("subCaseType", { custom: true, customValue: "" });
    } else {
      updateCaseData("subCaseType", choice);
    }
    setErrorMessage("");
  };

  const handleOtherSubcaseTypeChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    updateCaseData("subCaseType", { custom: true, customValue: value });
  };

  if (typeof caseType === "object" && caseType?.custom) {
    return null;
  }

  return (
    <SubmitSkeleton
      title="What do you want to report?"
      onPrev={handlePrev}
      onNext={handleNext}
      canProceed={!!canProceed}
      progress={1 / 10}
    >
      <div className="flex flex-col">
        {errorMessage && (
          <p className="text-red-500 text-sm mb-3">{errorMessage}</p>
        )}

        {allSubCases[caseType as string]?.map((choice) => (
          <label
            key={choice}
            className="flex items-center gap-3 pr-6 pl-[13px] cursor-pointer"
          >
            <input
              type="radio"
              name="subcase"
              value={choice}
              checked={
                typeof subCaseType === "string"
                  ? subCaseType === choice
                  : subCaseType?.custom && choice === "other"
                  ? true
                  : false
              }
              onChange={() => handleChange(choice)}
            />
            <span className="font-medium text-base leading-[16px] text-black py-4">
              {capitalizeFirstLetters(choice)}
            </span>
          </label>
        ))}

        {subCaseType &&
          typeof subCaseType === "object" &&
          subCaseType.custom && (
            <label className="flex flex-col gap-y-2">
              <span className="font-bold text-[14px] leading-[16.94px] text-black mt-2">
                Other
              </span>
              <input
                type="text"
                value={subCaseType.customValue}
                onChange={handleOtherSubcaseTypeChange}
                placeholder="Please specify..."
                className="border border-gray-3 py-2 px-3 rounded-md box-border outline-none focus:w-[99%] focus:ring-1 focus:ring-black focus:border-transparent "
              />
            </label>
          )}
      </div>
    </SubmitSkeleton>
  );
};

export default WhatToReportStage;
